import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NgxFileDropModule } from 'ngx-file-drop';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { EyrusAppComponent } from './app.component';

import { BaseAppModule } from '@base/app.module';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env/environment';
import { SharedModule } from '@base/shared/shared.module';
import { SharedModals } from '@eyrus/shared/components/modals';
import { EyrusSharedModule } from '@eyrus/shared/shared.module';
import { EyrusWarningModalComponent } from '@base/shared/components/warning-modal/warning-modal.component';
import { EyrusSharedResetPasswordModalComponent } from '@base-shared/components/reset-password-modal/reset-password-modal.component';
import { QuestionnaireModule } from './modules/contracts/reviewer/settings/questionnaire/questionnaire.module';

//import { NewTaskModalContent } from '@eyrus/modules/daily-logs/submitter/tasks/new-task-modal/new-task-modal.component'
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';


@NgModule({
  declarations: [
    EyrusAppComponent,
    //NewTaskModalContent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    NgbModule,
    SharedModule,
    EyrusSharedModule,
    NgxFileDropModule,
    QuestionnaireModule,
    BaseAppModule.forRoot({
      type: 'eyrus'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    Angulartics2Module.forRoot(),
  ],
  providers: [DatePipe],
  bootstrap: [EyrusAppComponent],
  entryComponents: [
    EyrusWarningModalComponent,
    EyrusSharedResetPasswordModalComponent,
    //NewTaskModalContent
  ],
  //schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class EyrusClientAppModule { }
